import { HistoryStack, HistoryStackEntry } from '../../state';

export const createGetHistoryStackEntryAtOffsetSelector = <S, N extends string>(
  getHistoryStackState: (state: S) => HistoryStack<N>,
  offset: number,
): ((state: S) => HistoryStackEntry<N> | null) => (
  state: S,
): HistoryStackEntry<N> | null => {
  const stack = getHistoryStackState(state);
  const entry = stack.entries[stack.index + offset] || null;
  return entry as HistoryStackEntry<N> | null;
};
